<template>
	<div class='common-wrap'>
		<div class="nav-wrap" v-if="isArticle&&routerZhName">
			<div class="flex">
				<i class="iconfont icon-home1"></i>
				<router-link class="link" :to="pidRouter">{{routerZhName}}</router-link>
				<template v-if="topNav.c_name">
					<!-- <i class="el-icon-arrow-right"></i>
					<router-link class="link" :to="subRouter">{{topNav.c_name}}</router-link> -->
					<i class="el-icon-arrow-right"></i>
					<!-- <router-link class="link" :to="subRouter" replace><span>{{routerZhName}}详情</span></router-link> -->
                    <span>{{routerZhName}}详情</span>
				</template>
			</div>
		</div>
		<div class="nav-wrap" v-if="isPublicity">
			<div class="flex">
				<i class="iconfont icon-home1"></i>
				<router-link class="link" to="publicity/main">信用公示</router-link>
				<i class="el-icon-arrow-right"></i>
				<router-link class="link" to="/common/bothPublic" replace><span>行政许可与行政处罚双公示</span></router-link>
			</div>
		</div>
		<div class="common-inner-wrap">
			<div class="image-wrap">
				<img src="../static/images/creditserver.png" alt="">
			</div>
			<div class="flex flex-row-between flex-items-start content-wrap">
				<div class="left-wrap ">
					<router-view @layoutInit="layoutInit" />
				</div>
				<div class="right-wrap">
					<commonRight :recommend="recommend" :isArticle="isArticle" :routerZhName="routerZhName" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { NAVLIST } from '@/utils/viewIndex'
import commonRight from '@/components/common-right'
export default {
	components: {
		commonRight
	},
	data() {
		return {
			recommend: [],
			topNav: {},
			menus: '' //来源一级页面 
		};
	},
	created() {

	},
	mounted() { },
	methods: {
		layoutInit({ recommend = [], nav = {}, menus = '' }) {
			console.log(recommend, nav, menus, 'routerZhName=', this.routerZhName);
			this.$set(this, 'recommend', recommend);
			this.$set(this, 'topNav', nav);
			this.$set(this, 'menus', menus);
		}
	},
	computed: {
		isPublicity() {
			return this.$route.path.includes('bothPublic')
		},
		isArticle() {
			return Object.keys(this.topNav).length > 0;
		},
		routerZhName() {
			// if (this.isArticle) {
			const { c_name } = this.topNav;
			switch (c_name) {
				case '1':
					return '信用动态';
				case '2':
					return '行业信用';
				case '3':
					return '诚信宣传';
				case '4':
					return '政策法规';
				case '5':
					return '信用研究';
				case '6':
					return '专项治理';
				case '7':
					return '风险提示';
				case '8':
					return '联合奖惩';
				case '9':
					return '通知公告';
				default:
					break;
			}
			// } else {
			// 	return this.menus;
			// }
		},
		navRouter() {
			const nav = NAVLIST.find(item => item.title === this.routerZhName) || {};
			return nav;
		},
		pidRouter() {
			const { link } = this.navRouter;
			if (!link) {
				return '/';
			} else {
				if (link.includes('dynamics')) {
					return link + '/国内动态'
				} else {
					return link;
				}
			}
		},
		subRouter() {
			const { c_name } = this.topNav;
			const { link } = this.navRouter;
			if (!link) {
				return '/';
			}
			return `${link}/${c_name}`;
		}
	},
	watch: {
	},

};
</script>
<style lang='scss' >
	$red: #d01c0b;

	.common-wrap {
		width: 100%;

		.common-inner-wrap {
			width: 1280px;
			margin: 0 auto;
			padding: 20px 0 20px;

			.content-wrap {
				padding-top: 20px;
				.left-wrap {
					width: 775px;
				}
				.right-wrap {
					width: calc(100% - 20px - 775px);
				}
			}
		}
	}
</style>